import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("token");

    if (accessToken) {
      if (config.headers) {
        config.headers["access-token"] = accessToken;
      }
    }

    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Only bounce to login when an actual session expired — a 401 on a
      // public page (no token) shouldn't cause a redirect loop.
      const hadToken = !!localStorage.getItem("token");
      localStorage.clear();
      if (hadToken && window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }
    return Promise.reject(error?.response?.data);
  }
);

export default axiosInstance;
